module.exports = __webpack_public_path__ + "img/manblock-image.6449f10e.png";